function Footer() {
  return (
    <footer className="pb-10 pt-5 bg-[#0B1120]">
      <div className="flex flex-col items-center justify-between mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="mt-6 text-base text-slate-500 md:mt-0">
          Built with passion by{" "}
          <a className="underline" href="https://myselfshravan.github.io/">
            Shravan
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
